/* eslint-disable max-len */
<template>
  <div id="app">
   <v-app light>
     <Header class="hidden-sm-and-down" />
     <HeaderMobile class="hidden-md-and-up" />
      <Datenschutz id="datenschutz"/>
  </v-app>
 </div>
</template>

<script>
import Header from '../components/molecules/Header.vue';
import HeaderMobile from '../components/molecules/HeaderMobile.vue';
import Datenschutz from '../components/molecules/Datenschutz.vue';


export default {
  components: {
    Header,
    HeaderMobile,
    Datenschutz,
  },
  data: () => ({

  }),
};
</script>

<style>
.parallax img { width: 100%; }
</style>
